import { FETCH_SIMILLIAR_REQUESTED } from "./actions";
import { SIMILLIAR_LOADED } from "./actions";
import { SIMILLIAR_ERROR } from "./actions";

const defaultState = {
  moviesSimilliar: [],
  loading: true,
  error: null
};

export const similliarReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_SIMILLIAR_REQUESTED:
      return {
        moviesSimilliar: [],
        loading: true,
        error: null
      };

    case SIMILLIAR_LOADED:
      return {
        moviesSimilliar: action.payload,
        loading: false,
        error: null
      };

    case SIMILLIAR_ERROR:
      return {
        moviesSimilliar: [],
        loading: false,
        error: true
      };

    default:
      return state;
  }
};
